import { render, staticRenderFns } from "./DialogClosePayrollPeriodConfirmation.vue?vue&type=template&id=190cb35e&scoped=true&"
import script from "./DialogClosePayrollPeriodConfirmation.vue?vue&type=script&lang=js&"
export * from "./DialogClosePayrollPeriodConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./DialogClosePayrollPeriodConfirmation.vue?vue&type=style&index=0&id=190cb35e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190cb35e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardActions,VCardText,VCardTitle,VCheckbox,VContainer,VDatePicker,VDialog,VIcon,VMenu,VSpacer,VTextField})
